'use strict';
const retryTimes = require('./retry-times');
module.exports = function retryNetworkError(retries) {
	const times = retryTimes(retries);
	return function (status) {
		return !!(times() && status === 'networkError');
	};
};
